import { appData } from '@/mocks/home';

export default function AppSection() {
  return (
    <section id="app" className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
              {appData.title}
            </h2>
            <p className="text-foreground-500 text-sm md:text-base leading-relaxed mb-6 max-w-lg">
              {appData.subtitle}
            </p>
            <div className="flex flex-wrap gap-2 mb-8">
              {appData.features.map((feat, idx) => (
                <span
                  key={idx}
                  className="inline-flex items-center gap-1.5 bg-background-50 border border-background-200 px-3 py-1.5 rounded-full text-xs font-medium text-foreground-600 whitespace-nowrap"
                >
                  <i className="ri-check-line text-primary-500 text-sm"></i>
                  {feat}
                </span>
              ))}
            </div>
            <div className="flex flex-col sm:flex-row gap-3">
              <a
                href={appData.downloadLinks.ios}
                className="inline-flex items-center justify-center gap-2 bg-foreground-900 hover:bg-foreground-800 text-white font-medium px-6 py-3 rounded-full text-sm transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-apple-fill text-lg"></i>
                iOS 下载
              </a>
              <a
                href={appData.downloadLinks.android}
                className="inline-flex items-center justify-center gap-2 bg-secondary-200 hover:bg-secondary-300 text-foreground-800 font-medium px-6 py-3 rounded-full text-sm transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-android-fill text-lg"></i>
                Android 下载
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center">
            <div className="relative">
              <div className="absolute -inset-6 bg-accent-500/5 rounded-3xl blur-3xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=A%20modern%20smartphone%20mockup%20displaying%20a%20news%20app%20interface%20with%20breaking%20news%20cards%2C%20warm%20red%20and%20dark%20theme%2C%20clean%20UI%20design%2C%20editorial%20news%20style%2C%20floating%20phone%20on%20simple%20background&width=600&height=700&seq=app-mockup&orientation=portrait"
                alt="黑料爆料 APP 移动端界面展示"
                className="relative w-56 md:w-64 h-auto"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}